import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-between align-items-center border-bottom p-3" }
const _hoisted_2 = { class: "d-flex" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "flex-1 ms-3" }
const _hoisted_5 = { class: "text-muted" }
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "text-muted" }
const _hoisted_8 = ["href"]
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "text-muted" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "text-muted" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "text-muted" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "text-muted" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "text-muted" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "text-muted" }
const _hoisted_21 = { class: "mt-2" }
const _hoisted_22 = { class: "ms-3 d-flex flex-column" }
const _hoisted_23 = ["onUpdate:modelValue", "disabled"]
const _hoisted_24 = {
  key: 1,
  class: "alert bg-soft-primary fw-medium",
  role: "alert"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "uil uil-info-circle fs-5 align-middle me-1" }, null, -1)
const _hoisted_26 = {
  key: 2,
  class: "d-flex gap-3"
}
const _hoisted_27 = {
  key: 0,
  class: "text-success"
}
const _hoisted_28 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_29 = {
  key: 2,
  class: "text-secodary"
}
const _hoisted_30 = {
  key: 3,
  class: "d-flex gap-3"
}
const _hoisted_31 = ["onClick", "disabled"]
const _hoisted_32 = ["onClick", "disabled"]
const _hoisted_33 = ["onClick", "disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.applications, (item, key) => {
      return (_openBlock(), _createElementBlock("div", {
        key: key,
        class: "col-12 mt-4 pt-2"
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", {
              innerHTML: item.avatar
            }, null, 8, _hoisted_3),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", null, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.pll[`Vacancy`]) + ": ", 1),
                _createElementVNode("a", {
                  href: item?.vacancy?.href,
                  target: "_blank"
                }, _toDisplayString(item.vacancy?.title), 9, _hoisted_6)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.pll[`Company`]) + ": ", 1),
                _createElementVNode("a", {
                  href: item?.company?.href,
                  target: "_blank"
                }, _toDisplayString(item.company?.title), 9, _hoisted_8)
              ]),
              _createElementVNode("div", null, [
                (item?.vacancy?.languages)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                      _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.pll[`Languages`]) + ": " + _toDisplayString(item.vacancy.languages), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", null, [
                (item?.vacancy?.experience)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                      _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.pll[`Experience`]) + ": " + _toDisplayString(item.vacancy.experience), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", null, [
                (item?.vacancy?.cv)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                      _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.pll[`CV`]) + ": " + _toDisplayString(item.vacancy.cv), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", null, [
                (item?.vacancy?.info_driving_licence)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                      _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.pll[`Driving licence`]) + ": " + _toDisplayString(item.vacancy.info_driving_licence), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", null, [
                (item?.vacancy?.car)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                      _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.pll[`Own car`]) + ": " + _toDisplayString(item.vacancy.car), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", null, [
                (item?.interviewer?.name)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                      _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.pll[`Interviewer`]) + ": " + _toDisplayString(item.interviewer.name), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("span", {
                  class: _normalizeClass(["badge", [item.status == 'screening' ? 'bg-danger' : 'bg-muted']])
                }, _toDisplayString(item.status), 3)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            (item.status == 'screening')
              ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                  key: 0,
                  cols: "50",
                  rows: "3",
                  "onUpdate:modelValue": ($event: any) => ((item.interviewer_comment) = $event),
                  disabled: item.validated !== null && item.validated !== '',
                  class: "form-control p-1 lh-sm mb-3"
                }, null, 8, _hoisted_23)), [
                  [_vModelText, item.interviewer_comment]
                ])
              : (item.interviewer_comment)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    _hoisted_25,
                    _createTextVNode(" " + _toDisplayString(item.interviewer_comment), 1)
                  ]))
                : _createCommentVNode("", true),
            (item.status !== 'screening')
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  (item.validated === 'valid')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(_ctx.pll[`Validated`]), 1))
                    : (item.validated === 'not_valid')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(_ctx.pll[`Not Validated`]), 1))
                      : (item.validated === 'regular')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(_ctx.pll[`Regular`]), 1))
                        : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_30, [
                  _createElementVNode("button", {
                    onClick: ($event: any) => (_ctx.set_validated(item.id, 'regular', item.interviewer_comment)),
                    disabled: _ctx.isLoading,
                    class: "btn btn-outline-secondary apply-button"
                  }, _toDisplayString(_ctx.pll[`Regular`]), 9, _hoisted_31),
                  _createElementVNode("button", {
                    onClick: ($event: any) => (_ctx.set_validated(item.id, 'not_valid', item.interviewer_comment)),
                    disabled: _ctx.isLoading,
                    class: "btn btn-outline-primary apply-button"
                  }, _toDisplayString(_ctx.pll[`Non-valid`]), 9, _hoisted_32),
                  _createElementVNode("button", {
                    onClick: ($event: any) => (_ctx.set_validated(item.id, 'valid', item.interviewer_comment)),
                    disabled: _ctx.isLoading,
                    class: "btn btn-primary apply-button"
                  }, _toDisplayString(_ctx.pll[`Valid`]), 9, _hoisted_33)
                ]))
          ])
        ])
      ]))
    }), 128))
  ]))
}